import AddUserOptions from 'pages/AddUser/AddUserForm/AddUserOptions/AddUserOptions';
import { getUserOptions } from 'pages/AddUser/AddUserForm/helper';
import { InviteSectionProps } from 'pages/AddUser/AddUserForm/OrgsAndDetailsSection/proptypes';
import { PermissionRole } from 'pages/AddUser/AddUserForm/types';
import UserDetailsSection from 'pages/AddUser/AddUserForm/UserDetailsSection/UserDetailsSection';
import { useInviteContext } from 'pages/AddUser/InviteProvider';
import { useTranslation } from 'react-i18next';
import { InviteUserOrgOptions } from 'types/types';
import { isGroupManager } from 'utils/role';

export const InviteUserSection = ({
  user,
  selectedOrgs,
  onRemoveOrg,
  formEmailAddress,
  setValue,
  control,
  setSelectedOrgs,
}: InviteSectionProps) => {
  const { t } = useTranslation();
  const {
    groups,
    organisationsInGroups,
    setFormState,
    formState: { permissionRole, selectedGroup, orgType, existingPractitioner },
  } = useInviteContext();

  return (
    <>
      <AddUserOptions
        selectedOrgs={selectedOrgs}
        setSelectedOrgs={(orgs) => {
          setSelectedOrgs(orgs);
        }}
        setSelectedGroup={(group) => {
          setFormState({ selectedGroup: group });
        }}
        selectedGroup={selectedGroup}
        orgType={orgType}
        setOrgType={(type) => {
          setFormState({ orgType: type });
        }}
        groups={groups}
        organisationsInGroups={organisationsInGroups}
        onRemoveOrg={onRemoveOrg}
        options={getUserOptions(
          t,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          existingPractitioner!,
          isGroupManager(user?.role),
        )}
        existingUser={false}
      />
      {selectedOrgs?.length > 0
        ? (orgType === InviteUserOrgOptions.ONE_ORG ||
            InviteUserOrgOptions.MULTI_ORG) && (
            <UserDetailsSection
              existingPractitioner={existingPractitioner}
              email={formEmailAddress ?? ''}
              control={control}
              permissionRole={permissionRole}
              setPermissionRole={(role: PermissionRole) => {
                setFormState({ permissionRole: role });
              }}
              setValue={setValue}
              selectedOrgs={selectedOrgs}
              isInsightsOrgSelected={selectedOrgs.some(
                (org) => org.name === 'Insights',
              )}
            />
          )
        : null}
    </>
  );
};
